import {
  forwardRef, useRef, useImperativeHandle, useId
} from 'react';

function TextCaption(
  {
    textContent,
    isOpen,
    contentMaxHeights,
    contentMaxHeight,
    contentMaxHeightOverride,
  },
  ref
) {
  const contentId = useId();
  const maxHeight = getMaxHeight(
    contentMaxHeights,
    contentId,
    contentMaxHeight,
    contentMaxHeightOverride
  );

  const contentRef = useRef(null);
  const captionRef = useRef(null);
  const containerRef = useRef(null);

  // used to keep track of dom elements for content
  useImperativeHandle(ref, () => ({
    contentRef: contentRef.current,
    captionRef: captionRef.current,
    containerRef: containerRef.current,
  }));

  const outerStyle = {
    height: isOpen ? `${maxHeight}px` : '0px',
    overflow: contentMaxHeight || contentMaxHeightOverride ? 'auto' : 'hidden',
  };

  const innerStyle = {
    height: contentMaxHeight || contentMaxHeightOverride ? '100%' : 'auto',
  };

  if (typeof textContent === 'string') {
    return (
      <figcaption id={contentId} ref={captionRef}>
        <div
          style={outerStyle}
          className="solid lds-tile-size-0 lds-figure-caption-tile"
        >
          <div ref={containerRef} className="lds-figure-caption-tile-container">
            <div
              ref={contentRef}
              dangerouslySetInnerHTML={{ __html: textContent }}
              style={innerStyle}
              className="lds-figure-caption-tile-content"
            />
          </div>
        </div>
      </figcaption>
    );
  }

  return (
    <figcaption id={contentId} ref={captionRef}>
      <div
        style={outerStyle}
        className="solid lds-tile-size-0 lds-figure-caption-tile"
      >
        <div ref={containerRef} className="lds-figure-caption-tile-container">
          <div
            ref={contentRef}
            style={innerStyle}
            className="lds-figure-caption-tile-content"
          >
            {textContent}
          </div>
        </div>
      </div>
    </figcaption>
  );
}

function getMaxHeight(
  contentMaxHeights,
  contentId,
  contentMaxHeight,
  contentMaxHeightOverride
) {
  if (contentMaxHeightOverride) {
    return contentMaxHeightOverride;
  }
  if (['small', 'medium', 'large'].includes(contentMaxHeight)) {
    return determineMaxHeight(contentMaxHeight);
  }
  return contentMaxHeights[contentId] || 0;
}

function determineMaxHeight(contentMaxHeight) {
  const heights = {
    small: 232,
    medium: 472,
    large: 712,
  };
  return heights[contentMaxHeight] || 0;
}
export default forwardRef(TextCaption);
